import React, { useState } from 'react';

const ActivitySelector = ({ selectedActivity, onActivityChange, className = "" }) => {
  const [hoveredActivity, setHoveredActivity] = useState(null);
  
  const activities = [
    { id: 'walk', emoji: '🚶', text: 'Walk', apiValue: 'walk' },
    { id: 'run', emoji: '🏃', text: 'Run', apiValue: 'run' },
    { id: 'cycle', emoji: '🚴', text: 'Cycle', apiValue: 'bike' },
    { id: 'travel', emoji: '🧳', text: 'Travel', apiValue: 'travel' }
  ];

  return (
    <div className={`flex justify-center space-x-4 mb-8 ${className}`}>
      {activities.map((activity) => (
        <button
          key={activity.id}
          className={`
            relative flex items-center justify-center
            w-16 h-16 rounded-full transition-all duration-300 ease-out
            shadow-lg hover:shadow-xl active:scale-95
            ${selectedActivity === activity.id 
              ? 'bg-blue-500 dark:bg-blue-600 scale-110 shadow-blue-200 dark:shadow-blue-800' 
              : 'bg-white dark:bg-gray-800 hover:scale-105 hover:bg-gray-50 dark:hover:bg-gray-700'
            }
            border border-gray-200 dark:border-gray-600
            backdrop-blur-sm
          `}
          onMouseEnter={() => setHoveredActivity(activity.id)}
          onMouseLeave={() => setHoveredActivity(null)}
          onFocus={() => setHoveredActivity(activity.id)}
          onBlur={() => setHoveredActivity(null)}
          onClick={() => onActivityChange(activity.id)}
          aria-label={`Select ${activity.text} activity`}
        >
          <span className={`text-2xl transition-transform duration-200 ${
            selectedActivity === activity.id ? 'scale-110' : ''
          }`}>
            {activity.emoji}
          </span>
          
          {/* Expanded text on hover/focus */}
          {hoveredActivity === activity.id && (
            <div className="absolute -bottom-10 left-1/2 transform -translate-x-1/2
                           bg-primary text-primary-foreground text-caption px-2 py-1 rounded-md
                           whitespace-nowrap opacity-90 z-10 shadow-lg
                           animate-in fade-in slide-in-from-top-1 duration-200">
              {activity.text}
              {/* Arrow pointing up */}
              <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 
                             w-2 h-2 bg-gray-900 dark:bg-gray-700 rotate-45"></div>
            </div>
          )}
        </button>
      ))}
    </div>
  );
};

export default ActivitySelector;